"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/Username/PatientPanel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _qrcodereact = require('qrcode.react');

var _AuthFrame = require('web/components/AuthFrame');
var _urls = require('web/services/urls');

const isMobileUserAgent = () =>
  typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

// Web has no patient sign-in (D-4): the Patient side says where patients go,
// and gets them the app: a QR code on a computer, a button on a phone. The
// smart link sends iOS to the App Store and Android to Google Play.
const PatientPanel = () => {
  const isPhone = _AuthFrame.useIsPhoneFrame.call(void 0, ) || isMobileUserAgent()

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "auth-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
        , _react2.default.createElement(_AuthFrame.PhoneIcon, { className: "auth-note--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}} )
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "Patients sign in on the BloomText app."      )
          , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 22}} ), "Open the link in your care team's text, then enter the code we send to your phone. No password needed."


        )
      )
      ,  isPhone
        ? (
            _react2.default.createElement('a', { href: _urls.appSmartLinkUrl, className: "blm-btn blm-btn--primary auth-patient-app--button"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Get the BloomText app"

            )
          )
        : (
            _react2.default.createElement('div', { className: "auth-patient-app--qr", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
              , _react2.default.createElement('div', { className: "auth-patient-app--qr-code", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
                , _react2.default.createElement(_qrcodereact.QRCodeSVG, { value: _urls.appSmartLinkUrl, size: 160, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
              )
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "Scan to get the BloomText app"     )
            )
          )
      , _react2.default.createElement('p', { className: "auth-small", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "Signup here is only for healthcare professionals. If you can't find your care team's text, contact your provider."


      )
    )
  )
}

exports. default = PatientPanel
